<template>
    <div class="stack mb-5">
        <div class="m-auto shadow text-left control-width border add-rounded p-4">
            <h5 class="mb-3 font-weight-bold kova-text">Brief introduction about yourself and your work experience</h5>            
            <!-- <a-textarea size="large" placeholder="I worked as senior developer at with name workplace..." class="m-auto" :autosize="{ minRows: 4, maxRows: 8 }"/> -->
            <vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="htmlForEditor" placeholder="Introduce yourself..."></vue-editor>
            <div>
                <h5 class="my-3 font-weight-bold kova-text">Have you led a team for software project/product development?</h5>
                <label for="opt1" class="radio text-left my-2">
                    <input type="radio" name="rdo" id="opt1" class="hidden"/>
                    <span class="label"></span>Yes
                </label><br />
                
                <label for="opt2" class="radio text-left my-2">
                    <input type="radio" name="rdo" id="opt2" class="hidden"/>
                    <span class="label"></span>No
                </label><br />
            </div>
            <div>
                <h5 class="font-weight-bold kova-text mt-3">Number of projects/products you've built as a team leader</h5> 
                <a-input-number class="ml-2 w-50" size="large" :min="0" :max="10" placeholder="0" @change="displayLink" /><br />
                <div :key="n" v-for="n in numLink">
                    <a-input class="mt-3 w-75" addonBefore="https://" placeholder="add project link" /><br/>
                </div>
            </div>
            <h5 class="mt-4 font-weight-bold kova-text">Country</h5>
            <a-select
                class="w-100" size="large" placeholder="Please select your Country">
                <a-select-option v-for="(item, index) in countries" :key="index"
                >{{item.name}}</a-select-option>
            </a-select>
            <h5 class="mt-4 font-weight-bold kova-text">City</h5>            
                <a-select
                class="w-100" size="large" placeholder="Please select your City">
                <a-select-option v-for="(item, index) in countries" :key="index"
                >{{item.capital}}</a-select-option>
            </a-select>
            <hr />
            <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                <div class="row">
                    <div class="col text-left">
                        <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                    </div>
                    <div class="col text-right">
                         <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                    </div>
                </div>
            </div>
            
        </div>
        
 </div>
</template>
<script>

import { VueEditor } from "vue2-editor";

export default {
    name: 'stack',
    components: {
        VueEditor
    },
    data(){
        return {
            countries: [],
            numLink: 0,
            VueEditor
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1);
        },
        next(){
            this.$router.push('/register')
        },
        displayLink(value){
            this.numLink = value;
        },
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        
            var formData = new FormData();
            formData.append("file", file);
        
            this.$http({
                url: "https://fakeapi.yoursite.com/images",
                method: "POST",
                data: formData
            })
            .then(result => {
            let url = result.data.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "file", url);
            resetUploader();
            })
            // .catch(err => {
            // console.log(err);
            // });
        }
    },
    mounted(){
        this.$http({
            method: 'GET',
            url:'https://ajayakv-rest-countries-v1.p.rapidapi.com/rest/v1/all',
            headers: {
                "x-rapidapi-host": "ajayakv-rest-countries-v1.p.rapidapi.com","x-rapidapi-key": "6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d"
            }
        }).then((response) => {
            this.countries = response.data
            // console.log(response.data)
        })
        
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}

@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>